import { Role } from "@/modules/roles/composables/useRoles";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useRoleStore = defineStore("role", () => {
  const role = ref<Role>();

  return {
    role,

    setRole(newRole: Role) {
      role.value = newRole;
    },
  };
});
